import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {newsletterEmailPreview_template} from "./newsletterEmailPreview_template";

declare var ko: any;

export class newsletterMailView_template extends vnTemplate {

    protected emailPreview: newsletterEmailPreview_template;

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            subject: ko.observable(""),
            previewText: ko.observable(""),
            html: ko.observable(""),
            mode: ko.observable(""),
            selectedTemplate: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            permissions: ko.observableArray(this.initPermissions([ 'newsletter_email_view', 'newsletter_email_edit'])),
            onClickEditNewsletterMail (data) {
                self.onClickEditNewsletterMail(data.id());
            },
            onClickCancel () {
                self.onClickCancel();
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`


            <div class="w-form w-form-large w-form-article-view">

                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <div class="w-btn">
                         <button data-bind="event: { click: onClickEditNewsletterMail }, visible: permissions()['newsletter_email_edit'].read" class="btn icon i-edit"  type="button">Edit Newsletter Mail</button>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Info</strong>
                    </div>
                </div>
                <div class="w-form-body">

                    <div class="form-body">
                        <div class="form-group ">
                            <dl class="double-list">
                                <dt>Subject</dt>
                                <dd data-bind="text: subject"></dd>
                            </dl>
                            <dl class="double-list">
                                <dt>Preview Text</dt>
                                <dd data-bind="text: previewText"></dd>
                            </dl>
                            <dl class="double-list">
                                <dt>Layout</dt>
                                <dd data-bind="text: mode"></dd>
                            </dl>
                            <dl class="double-list">
                                <dt>Template</dt>
                                <dd data-bind="text: selectedTemplate() && selectedTemplate().name ? selectedTemplate().name : '' "></dd>
                            </dl>
                         </div>
                    </div>

                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Content</strong>
                    </div>
                </div>

                <div class="w-form-body">

                    <div class="form-body">
                        <div class="form-group form-group-content">
                            ${ this.emailPreview.getHtmlBuild() }
                         </div>
                    </div>

                </div>
        `);
    }

    protected initPartial(): void {
        this.emailPreview = new newsletterEmailPreview_template("newsletterEmailPreview", this.getTemplateViewModel(), this);
    }

    protected setNewsletterMailData(newsletterMail) {

        this.getTemplateViewModel().id(newsletterMail.id);
        this.getTemplateViewModel().subject(newsletterMail.subject);
        this.getTemplateViewModel().previewText(newsletterMail.previewText);
        this.emailPreview.setHtml(newsletterMail.content);
        this.getTemplateViewModel().mode(newsletterMail.mode);
        this.getTemplateViewModel().selectedTemplate(newsletterMail.selectedTemplate);
        this.getTemplateViewModel().dateCreated(newsletterMail.dateCreated);
        this.getTemplateViewModel().dateUpdated(newsletterMail.dateUpdated);
    }

    protected getTemplateName(): string {
        return "newsletterMailsView_template";
    }

    protected onClickEditNewsletterMail(id: any): any {
        this.caller.onClickEditNewsletterMail(id)
    }

    private viewOnWebsite(value) {

        // prevent click to trigger onClick bindings of outer elements that are also targeted by click
        window.event.stopPropagation();
        this.caller.viewOnWebsite(value.permalink());
    }

    protected onClickCancel(): any {
        this.caller.onClickCancel()
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterMailView_template.ts